import axios from 'axios';

import api from '../api';

export const getMarkets = () => api.get('/api/v1/markets');
export const getMarketsFallback = () =>
  axios
    .create({
      baseURL: '',
    })
    .get('/rewards/markets.json');
